module.exports = __webpack_public_path__ + "static/media/blue-card-4.1a743b0b.png";